module.exports = __webpack_public_path__ + "static/media/gls.10e046e7.png";